module.exports = __webpack_public_path__ + "static/media/google-1-add-code.5e77e71a.png";